import { Injectable } from '@angular/core';
import { BackendMessageTranslationService } from './error-translation.service';

@Injectable({
  providedIn: 'root',
})
export class TranslationHelperService {
  private translations: any = {};

  constructor(
    private backendMessageTranslation: BackendMessageTranslationService,
  ) {
    // Load translations from window (loaded by i18n.module.ts)
    if (window.hasOwnProperty('translations')) {
      this.translations = (window as any).translations;
    }
  }

  /**
   * Translate backend message using backend message translation service
   * @param backendMessage The message from backend
   * @returns Translated message or original message if translation not found
   */
  translateBackendMessage(backendMessage: string): string {
    const translationKey =
      this.backendMessageTranslation.getTranslationKey(backendMessage);

    // Use runtime translations instead of $localize
    return this.translations[translationKey] || backendMessage;
  }
}
